import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

// components
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn';
import SecondaryBtn from '../../../../components/btns/secondary-btn/SecondaryBtn';
import InputDropdown from '../../../../components/input-dropdown/InputDropdown';
import InputBar from '../../../../components/input-bar/InputBar';

// PSA constants
import { GRADING_SERVICES_WITH_PRICES, GRADING_SERVICES } from '../../../../utils/psa/psa.constants';

// styles
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  ModalFooter,
  ButtonGroup,
} from './NewSubmissionModal.styles';

export default function NewSubmissionModal({
  isOpen,
  onClose,
  onCreateSubmission
}) {
  const [psaSubmissionID, setPsaSubmissionID] = useState('');
  const [selectedService, setSelectedService] = useState('');

  // Reset form when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setPsaSubmissionID('');
      setSelectedService('');
    }
  }, [isOpen]);

  const handleClose = () => {
    setPsaSubmissionID('');
    setSelectedService('');
    onClose();
  };

  const handleCreateSubmission = () => {
    if (onCreateSubmission) {
      // Extract service name from formatted string if selected
      let serviceLevel = null;
      if (selectedService) {
        const sortedServices = [...GRADING_SERVICES].sort((a, b) => b.length - a.length);
        serviceLevel = sortedServices.find(service =>
          selectedService.startsWith(service)
        ) || selectedService;
      }

      onCreateSubmission({
        psaSubmissionID: psaSubmissionID.trim() || '',
        serviceLevel: serviceLevel
      });
    }
  };

  if (!isOpen) return null;

  const modalContent = (
    <ModalOverlay onClick={handleClose} className='widget-bg'>
      <ModalContainer onClick={(e) => e.stopPropagation()} className='panel-bg'>
        <ModalHeader>
          <ModalTitle>New Submission</ModalTitle>
          <CloseButton onClick={handleClose}>×</CloseButton>
        </ModalHeader>

        <ModalBody>
          <InputBar
            type="text"
            value={psaSubmissionID}
            updateValue={setPsaSubmissionID}
            id="psa-submission-id"
            label="PSA Submission ID"
            pH="PSA Submission ID"
          />

          <InputDropdown
            id="service-level"
            label="Service level"
            value={selectedService}
            onChange={setSelectedService}
            options={GRADING_SERVICES_WITH_PRICES}
            placeholder="Select service..."
            size="compact"
          />
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <SecondaryBtn
              title="CANCEL"
              onClick={handleClose}
            />
            <PrimaryBtn
              title="CREATE SUBMISSION"
              onClick={handleCreateSubmission}
            />
          </ButtonGroup>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>
  );

  return createPortal(modalContent, document.body);
}
